document.getElementById("signup-form").addEventListener('submit', (event) => {
  const loading = document.querySelector('.loading')
  loading.style.display = 'flex'

  const emailElement = event.target.email 
  const passwordElement = event.target.password
  const passwordConfirmElement = event.target.passwordConfirm
  const signUpCodeElement = event.target.signUpCode 
 
  const isEmailValid = checkEmail(emailElement)
  const isPasswordValid = checkPassword(passwordElement)
  const isPasswordConfirmValid = checkPasswordConfirm(passwordElement, passwordConfirmElement)
  const isSignUpCodeValid = checkSignUpCode(signUpCodeElement)
  const isValid = isEmailValid && isPasswordValid && isPasswordConfirmValid && isSignUpCodeValid
  
  if (!isValid) {
    event.preventDefault()
    loading.style.display = 'none'
  } 
})